import { render, staticRenderFns } from "./ResultFormSe.vue?vue&type=template&id=cfc00f2c&scoped=true&"
import script from "./ResultFormSe.vue?vue&type=script&lang=js&"
export * from "./ResultFormSe.vue?vue&type=script&lang=js&"
import style0 from "./ResultFormSe.vue?vue&type=style&index=0&id=cfc00f2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc00f2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfc00f2c')) {
      api.createRecord('cfc00f2c', component.options)
    } else {
      api.reload('cfc00f2c', component.options)
    }
    module.hot.accept("./ResultFormSe.vue?vue&type=template&id=cfc00f2c&scoped=true&", function () {
      api.rerender('cfc00f2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ToolAssistant/ocr/components/ResultFormSe.vue"
export default component.exports